import { render, staticRenderFns } from "./specialistPage.vue?vue&type=template&id=20e60844&"
import script from "./specialistPage.vue?vue&type=script&lang=js&"
export * from "./specialistPage.vue?vue&type=script&lang=js&"
import style0 from "./specialistPage.vue?vue&type=style&index=0&id=20e60844&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports